import Breadcrumb from '@/components/breadcrumb/Breadcrumb';
import AllCategories from '@/components/categories/All-Categories';
import { motion } from 'framer-motion';
import SEO from '@/components/seo/SEO';

const categoryData = [
  {
    title: "Refrigeration & Cooling",
    description: "Designed for efficiency, durability, and optimal temperature control. Our solutions ensure maximum freshness and energy savings.",
    products: [
      { name: "Oven & Microwave", img: "/images/catg6.png" },
    { name: "Butchery Equipment", img: "/images/catg5.png" },
    { name: "Cooking Line", img: "/images/catg4.png" },
    { name: "Dishwasher", img: "/images/catg3.png" },
    { name: "Chillers", img: "/images/catg2.png" },
    { name: "Ice Maker", img: "/images/categ1.png" },
    { name: "Oven & Microwave", img: "/images/catg6.png" },
    { name: "Butchery Equipment", img: "/images/catg5.png" },
    { name: "Cooking Line", img: "/images/catg4.png" },
    { name: "Dishwasher", img: "/images/catg3.png" },
    { name: "Chillers", img: "/images/catg2.png" },
    { name: "Ice Maker", img: "/images/categ1.png" },
    { name: "Oven & Microwave", img: "/images/catg6.png" },
    { name: "Butchery Equipment", img: "/images/catg5.png" },
    { name: "Cooking Line", img: "/images/catg4.png" },
    { name: "Dishwasher", img: "/images/catg3.png" },
    { name: "Chillers ", img: "/images/catg2.png" },
    { name: "Ice Maker", img: "/images/categ1.png" },
    ]
  },
  {
    title: "Cooking & Heating Equipment",
    description: "Designed for professional and home kitchens alike. Our range meets even heating, durability, and superior performance for all your culinary needs.",
    products: [
      { name: "Chillers", img: "/images/catg2.png" },
      { name: "Ice Maker", img: "/images/categ1.png" },
      { name: "Oven & Microwave", img: "/images/catg6.png" },
    ]
  },
  {
    title: "Food Preparation & Processing",
    description: "Designed for professional and home kitchens alike. Our range meets even heating, durability, and superior performance for all your culinary needs.",
    products: [
      { name: "Ice Maker", img: "/images/categ1.png" },
    { name: "Oven & Microwave", img: "/images/catg6.png" },
    ]
  }
];

const Index = () => {
  return (
    <>
      <SEO 
        title="Categories | Steel Kitchen"
        description="Explore our comprehensive range of kitchen equipment categories including refrigeration, cooking, and food preparation solutions."
        keywords="kitchen equipment, refrigeration, cooking equipment, food preparation, commercial kitchen"
        ogImage="/images/categories-og.jpg"
      />
      <Breadcrumb/>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
      >
        <AllCategories categories={categoryData} />
      </motion.div>
    </> 
  );
};

export default Index;